import { combineReducers } from 'redux';

import { SeatMapState } from './types';

import seatMapReducer from './seatMap/reducers';
import additionalServicesReducer from './additionalServices/reducers';
import passengersReducer from './passengers/reducers';
import selectedPassengerIdReducer from './selectedPassengerId/reducers';
import selectedSegmentIdReducer from './selectedSegmentId/reducers';
import selectedSeatsReducer from './selectedSeats/reducers';
import activeRecommendedSeatsReducer from './activeRecommendedSeats/reducers';
import selectedPassengersFiltersReducer from './selectedPassengersFilters/reducers';
import showSuggestionModalReducer from './showSuggestionModal/reducers';

const rootReducer = combineReducers<SeatMapState>({
	seatMap: seatMapReducer,
	additionalServices: additionalServicesReducer,
	passengers: passengersReducer,
	selectedPassengerId: selectedPassengerIdReducer,
	selectedSegmentId: selectedSegmentIdReducer,
	selectedSeats: selectedSeatsReducer,
	selectedPassengersFilters: selectedPassengersFiltersReducer,
	activeRecommendedSeats: activeRecommendedSeatsReducer,
	showSuggestionModal: showSuggestionModalReducer
});

export default rootReducer;
